import React, { useRef } from 'react';
import StorePackageWalkAppointment from './StorePackageWalkAppointment';
import PricePlanCard from './PlanPackage';
import PackagePlanHeadingText from './PackagePlanHeadingText';
import './salesbooking-page.scss';
import WindowSharingRevenue from '../priceplan-page/WindowSharingRevenue';
import RevenueSharing from '../priceplan-page/RevenueSharing';
import RestaurantRoadmap from '../priceplan-page/RestaurantRoadmap';

function StorePackageWalk() {
  const pageRef = useRef(null);

  // On desktop/iPad the page lives inside `.pagebase-container` (overflow-y: auto) while
  // `.app-main-layout` is overflow: hidden, so the window never scrolls. Scroll the nearest
  // scrollable ancestor, and fall back to the window (mobile layout).
  const scrollToBooking = () => {
    let el = pageRef.current?.parentElement;
    while (el && el !== document.body) {
      const { overflowY } = window.getComputedStyle(el);
      if (/(auto|scroll)/.test(overflowY) && el.scrollHeight > el.clientHeight) {
        el.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      el = el.parentElement;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  return (
    <div
      ref={pageRef}
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* PAGE CONTENT */}
      <div style={{ flex: 1, overflow: 'visible' }}>
        {
          <>
            <StorePackageWalkAppointment />
            <section className='store-package-walk__pricing'>
              <PackagePlanHeadingText />
              <PricePlanCard scrollToBooking={scrollToBooking} />
              <RevenueSharing />
              <WindowSharingRevenue />
              <RestaurantRoadmap />
              <div
                style={{
                  // marginTop: 5,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 16,
                  flexWrap: 'wrap',
                  textAlign: 'center',
                  marginBottom: 30,
                }}
              >
                <span style={{ fontSize: 18, color: 'black' }}>
                  Want early access to beta features?
                </span>
                <button
                  type='button'
                  className='roadmap-cta'
                  onClick={() => {
                    scrollToBooking();
                  }}
                  style={{
                    background: 'black',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 999,
                    padding: '11px 22px',
                    fontSize: 16,
                    fontWeight: 600,
                    fontFamily: 'inherit',
                    cursor: 'pointer',
                    transition: 'background 0.15s',
                  }}
                >
                  Let's Connect
                </button>
              </div>
            </section>
          </>
        }
      </div>

      {/* FOOTER */}
      <div
        style={{
          display: 'flex',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: 'rgba(235, 235, 235, 0.8)',
          height: '35px',
          padding: '0 5vw',
          fontSize: '12px',
          color: '#5a5a5a',
        }}
      >
        © 2026 SingleCombo • All rights reserved.
      </div>
    </div>
  );
}

export default StorePackageWalk;
